export default {"src":"/_next/static/media/ReadingTime.496c4a22.svg","height":160,"width":160,"blurWidth":0,"blurHeight":0};